<template>
  <div class="relative">
    <span class="pointer-events-none absolute top-1/2 left-3 z-10 -translate-y-1/2 text-sm text-muted-foreground">{{ symbol }}</span>
    <number-input
      v-model="insideValue"
      :style="{ paddingLeft: (symbol.length * 0.6 + 1.25) + 'rem' }"
      :disabled="disabled"
      :min="min"
      :step="step"
      :decimals="2"
      @blur="$emit('blur')"
    />
  </div>
</template>

<script>
import NumberInput from '@/ui/components/NumberInput.vue';

export default {
  name: 'MoneyInput',
  components: {
    NumberInput,
  },
  props: {
    modelValue: {
      type: [ Number, String, null ],
      required: false,
      default: () => null,
    },
    currency: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      default: () => 0,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    insideValue: '',
  }),
  computed: {
    currencyDetails() {
      return this.$store.getters['app/currencies'].find(i => i.code === this.currency);
    },
    symbol() {
      return this.currencyDetails ? this.currencyDetails.symbol : '';
    },
    step() {
      return this.currencyDetails ? (1 / this.currencyDetails.offset) : 1;
    },
  },
  watch: {
    insideValue() {
      this.$emit('update:modelValue', this.insideValue);
    },
    modelValue: {
      immediate: true,
      handler() {
        this.insideValue = this.modelValue;
      },
    },
  },
};
</script>
